module.exports = __webpack_public_path__ + "cc08f7935373039ad2717fe4ec9ac699.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/GB-WLS.svg
// module id = UFOd
// module chunks = 0